import './App.css';
import Header from './component/header';
import IconHero from './images/illustration-hero.svg';
import Middle from './component/middle-area';
import Extension from './component/extension';
import Faq from './component/faq';
import Footer from './component/footer';
import logo from "./images/gg.svg";
import facebook from"./images/icon-facebook.svg";
import twitter from"./images/icon-twitter.svg";



function App() {
  return (
    <div className="App">
      <Header />
      <div className="top-area">
        <div className="left-area">
          <h1 className="hero-line">
            A Simple Bookmark Manager
          </h1>
          <p className="hero-para">
            A clean and simple interface to organize your favourite websites. Open a new browser tab and see your sites load instantly. Try it for free.
          </p>
          <div className="buttons">
            <button className='chrome'>  Get it on Chrome
            </button>
            <button className='firefox'>  Get it on Firefox
            </button>
          </div>

        </div>
        <div className="right-area">
          <img src={IconHero} alt="icon hero" />
          <div className="shape"></div>
        </div>
      </div>
      <Middle/>
      <Extension/>
      <Faq/>
      <Footer/>
      <div className="blue-area">
        <div className="left">
        <div className="header-area">           
            <img src={logo} alt="bookmark" className="logo" />
            <div className="menu-bar">
                <ul>
                    <li>features </li>
                    <li>Pricing</li>
                    <li>Contact</li>
                </ul>
            </div>
        </div>

        </div>
        <div className="right">
        <img src={facebook} alt="bookmark-1" className="logo-2" />
        <img src={twitter} alt="bookmark-2" className="logo-3" />



        </div>
      </div>



    </div>
  );
}

export default App;
